import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from '@fuxi/eevee-ui';
import classnames from 'classnames/bind';
import { useActivityCenterFromLoginCheck, useLoginAuthCheck, useLoginNoAuthRedirect } from 'common-package/src/hooks';
import { SubPackageSlugEnum } from '@yaotai/common-utils';
import { NavHeader, BindMobileBanner, BindMobileModal } from '@/components';
import { BASIC_LAYOUT_ID } from '@/constants';
import { useLangConfig, useBindModalCheck } from '@/hooks';
import styles from './style.module.less';

const cx = classnames.bind(styles);

const { Content } = Layout;

export const UserLayout = () => {
  const modalRef = useRef<ModalRef>(null);

  useLoginNoAuthRedirect({ noAuthRedirectUrl: `/${SubPackageSlugEnum.Center}/login` });
  // useFavicon(DEFAULT_ICO);

  const { showBindBanner } = useBindModalCheck();
  useLangConfig();
  useLoginAuthCheck();
  useActivityCenterFromLoginCheck();
  return (
    <Layout id={BASIC_LAYOUT_ID} className={cx('basic-layout')}>
      <NavHeader
        oemPageMode="user"
        style={{
          position: 'fixed',
          top: 0,
          width: '100%',
        }}
      />
      <div className={cx('content')}>
        {showBindBanner && <BindMobileBanner />}
        <Content className={cx('main')}>
          <Outlet />
        </Content>
      </div>
      <BindMobileModal ref={modalRef} />
    </Layout>
  );
};
